import theme from '@/utilities/Theme'
import { Checkbox, ListItemText, Menu, MenuItem } from '@mui/material'
import { FC } from 'react'

interface FilterMenuProps {
  anchorEl: HTMLElement | null
  selectedOption: string | null
  showMenu: boolean
  options: {
    label: string
    value: string
  }[]
  handleClose: () => void
  handleSelect: (value: string) => void
}

export const FilterMenu: FC<FilterMenuProps> = ({
  anchorEl,
  selectedOption,
  showMenu,
  options,
  handleClose,
  handleSelect,
}) => {
  return (
    <Menu
      id="single-checkbox-menu"
      anchorEl={anchorEl}
      open={showMenu}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'filter-button',
      }}
      PaperProps={{
        sx: {
          maxHeight: 200,
          overflowY: 'auto',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          },
        },
      }}
    >
      {options.map(({ label, value }) => (
        <MenuItem
          key={value}
          onClick={() => handleSelect(value)}
          sx={{ fontSize: '12px', paddingY: '4px' }}
        >
          <Checkbox
            checked={selectedOption === value}
            sx={{
              padding: 0,
              marginRight: '8px',
              '& .MuiSvgIcon-root': { fontSize: '14px' },
            }}
          />
          <ListItemText secondary={label} sx={{ fontSize: '16px' }} />
        </MenuItem>
      ))}
    </Menu>
  )
}
